import React from 'react';
import '../styles/Testimonials.css';
import Header from '../components/Header';
import Footer from'../components/Footer';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Samuel O.",
      role: "Civil Engineer",
      message:
        "Using CyberKonstruct's estimator saved me hours of manual work. The concrete and mortar estimation were spot on!",
    },
    {
      name: "Fatima A.",
      role: "Site Manager",
      message:
        "This tool made our cost planning faster and more accurate. I can't wait for the roof estimator to launch!",
    },
    {
      name: "Daniel E.",
      role: "Student / Intern",
      message:
        "I used the platform during my school project. It made me understand material calculation more practically.",
    },
    {
      name: "Abdulkareem A.",
      role: "Quantity Surveyor",
      message:
        "This tool made my BOQ faster and more accurate and the Web is user friendly!.",
  }
  ];

  return (
    <div>
      <Header/>
    <div className="testimonials-section">
      <h2>What Our Users Are Saying</h2>
      <div className="testimonial-list">
        {testimonials.map((item, index) => (
          <div key={index} className="testimonial-card">
            <p className="message">“{item.message}”</p>
            <p className="user"><strong>{item.name}</strong>, {item.role}</p>
          </div>
        ))}
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default Testimonials;
